import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import classNames from 'classnames';
import fetch from 'node-fetch';
import parseSRT from 'parse-srt';
import PropTypes$1 from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';
import 'whatwg-fetch';
import { PropTypes } from '@micromag/core';
import { getSecondsFromTime } from '@micromag/core/utils';

var styles = {"container":"micromag-element-closed-captions-container","captions":"micromag-element-closed-captions-captions"};

var propTypes = {
  media: PropTypes.closedCaptionsMedia,
  currentTime: PropTypes$1.number,
  // in seconds
  timeOffset: PropTypes$1.string,
  // in srt time format (10:00:01,034)
  className: PropTypes$1.string
};
var defaultProps = {
  media: null,
  currentTime: 0,
  timeOffset: null,
  className: null
};
var ClosedCaptions = function ClosedCaptions(_ref) {
  var currentTime = _ref.currentTime,
    timeOffset = _ref.timeOffset,
    media = _ref.media,
    className = _ref.className;
  var _ref2 = media || {},
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    lines = _useState2[0],
    setLines = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    lineIndex = _useState4[0],
    setLineIndex = _useState4[1];
  var startOffset = timeOffset !== null ? timeOffset.split(/[\t ]*-->[\t ]*/) : null;
  var startSeconds = startOffset !== null && startOffset.length ? getSecondsFromTime(startOffset[0]) : 0;
  useEffect(function () {
    if (url === null) {
      return;
    }
    fetch(url, {
      mode: 'cors'
    }).then(function (response) {
      return response.text();
    }).then(function (srt) {
      return parseSRT(srt);
    }).then(function (parsed) {
      setLines(parsed);
    })["catch"](function (e) {
      console.error(e);
    });
  }, [url, fetch, setLines]);
  var getLineIndexFromTime = useCallback(function (t) {
    var currentLineIndex = lines.findIndex(function (line) {
      return t >= line.start - startSeconds && t <= line.end - startSeconds;
    });
    return currentLineIndex;
  }, [lines, startSeconds]);
  useEffect(function () {
    if (lines.length > 0) {
      var nextLineIndex = getLineIndexFromTime(currentTime);
      if (nextLineIndex !== lineIndex) {
        setLineIndex(nextLineIndex);
      }
    }
  }, [currentTime, lines, getLineIndexFromTime, setLineIndex]);
  var line = lineIndex !== -1 ? lines[lineIndex] : null;
  var active = line !== null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, active ? /*#__PURE__*/React.createElement("div", {
    className: styles.captions,
    dangerouslySetInnerHTML: active ? {
      __html: line.text
    } : null
  }) : null);
};
ClosedCaptions.propTypes = propTypes;
ClosedCaptions.defaultProps = defaultProps;

export { ClosedCaptions as default };
